import { ActionTypes } from "../constants/action-types";

export const setMenuSelected = (selected) => {
    //console.log("setMenuSelected called")
    return {
        type: ActionTypes.CHANGE_MENU_SELECTION,
        payload: selected
    };
};